"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.monthMap = void 0;
const getMonthOverview_1 = __importDefault(require("./gql/getMonthOverview"));
const getCurrentCustomers_1 = __importDefault(require("./gql/getCurrentCustomers"));
exports.monthMap = {
    0: "JANUARY",
    1: "FEBRUARY",
    2: "MARCH",
    3: "APRIL",
    4: "MAY",
    5: "JUNE",
    6: "JULY",
    7: "AUGUST",
    8: "SEPTEMBER",
    9: "OCTOBER",
    10: "NOVEMBER",
    11: "DECEMBER",
};
class MonthlyCustomerOverview {
    constructor(client) {
        this.client = client;
        this.getMonthlyCustomerOverview = async (year, month) => {
            const response = await this.client.fetch("getMonthOverview", getMonthOverview_1.default, {
                year,
                month: this.mapMonthNumberToMonth(month),
            });
            const currentMemberLst = await this.client.fetch("getCurrentCustomers", getCurrentCustomers_1.default, null);
            return response.coachMonthOverview.traineesSummary.map(this.adaptMemberOverview(currentMemberLst.coachTrainees));
        };
        this.mapMonthNumberToMonth = (month) => exports.monthMap[month];
        this.isCoachMember = (memberId, memberList) => memberList.some((member) => member.id === memberId);
        this.adaptMemberOverview = (currentMemberList) => (apiMember) => {
            return {
                id: apiMember.trainee.id,
                name: `${apiMember.trainee.firstName} ${apiMember.trainee.lastName}`,
                isCoachMember: this.isCoachMember(apiMember.trainee.id, currentMemberList),
                events: apiMember.events.map((event) => ({
                    eventName: event.modelName,
                    startDate: event.start.iso8601.split("T")[0],
                    endDate: event.end.iso8601.split("T")[0],
                    days: event.days,
                    reasonStart: event.reasonStart,
                    reasonEnd: event.reasonEnd,
                })),
            };
        };
    }
}
exports.default = MonthlyCustomerOverview;
//# sourceMappingURL=MonthlyCustomerOverview.js.map